module.exports = __webpack_public_path__ + "img/demo01.cfd1dd04.jpg";